import React from 'react';
import { Link } from 'react-router-dom';
import LanguageControl from '../i18n/LanguageControl';
import { isEnglish } from '../i18n/locale';
import usePageMetadata from '../hooks/usePageMetadata';
import { JIKEYIXIA } from '../data/jikeyixia';
import icon from '../assets/jikeyixia-icon.svg';

export function useJikePage(title, description, path) {
  usePageMetadata(title, description, path, 'jike-page-active');
}

export function JikeHeader({ privacy = false }) {
  return <header className="jike-header">
    <Link to={JIKEYIXIA.path} className="jike-wordmark"><img src={icon} alt="" width="38" height="38" /><span>{isEnglish ? JIKEYIXIA.name.en : JIKEYIXIA.name.zh}</span></Link>
    <nav className="jike-header-links" aria-label={isEnglish ? 'Product navigation' : '产品导航'}>
      {privacy ? <Link to={JIKEYIXIA.path}>{isEnglish ? 'Product' : '产品介绍'}</Link> : <><a className="jike-nav-secondary" href="#features">{isEnglish ? 'Features' : '功能'}</a><a className="jike-nav-secondary" href="#questions">FAQ</a><Link to={JIKEYIXIA.privacyPath}>{isEnglish ? 'Privacy' : '隐私'}</Link></>}
      <LanguageControl />
    </nav>
  </header>;
}

export function JikeFooter() {
  return <footer className="jike-footer">
    <Link to="/" className="jike-peacetech">PeaceTech<span>Independent tools, thoughtfully made.</span></Link>
    <div><Link to={JIKEYIXIA.path}>{isEnglish ? 'Product' : '产品介绍'}</Link><Link to={JIKEYIXIA.privacyPath}>{isEnglish ? 'Privacy policy' : '隐私政策'}</Link><a href={`mailto:${JIKEYIXIA.supportEmail}`}>{isEnglish ? 'Contact' : '联系与反馈'}</a></div>
    <p>{isEnglish ? 'An independent extension. Not affiliated with X or Jike.' : '独立第三方扩展，与 X 或即刻官方无隶属关系。'}<br />© {new Date().getFullYear()} PeaceTech</p>
  </footer>;
}

export function DownloadLink() {
  return <a className="jike-cta jike-cta-download" href={JIKEYIXIA.downloadUrl} download={`jikeyixia-${JIKEYIXIA.version}.zip`}>
    {isEnglish ? 'Download ZIP' : '下载插件 ZIP'}<span aria-hidden="true">↓</span>
  </a>;
}

export function ChromeStoreLink({ secondary = false }) {
  return <a className={`jike-cta ${secondary ? 'jike-cta-light' : ''}`} href={JIKEYIXIA.chromeStoreUrl} target="_blank" rel="noopener noreferrer">
    {isEnglish ? 'Chrome Web Store' : '前往 Chrome 应用商店'}<span aria-hidden="true">↗</span>
  </a>;
}

export function InstallActions({ dark = false }) {
  return <div className="jike-install-actions"><DownloadLink /><ChromeStoreLink secondary={dark} /></div>;
}
